/**
 * Strips LaTeX delimiters and commands from a plain text string so it reads
 * naturally in list/card previews without rendering math.
 * e.g. "$\frac{1}{2}$" → "1/2",  "$$x^2 + 1$$" → "x^2 + 1"
 */
const stripLatex = (text) => {
  if (!text) return text;
  return text
    // Remove display math $$...$$ and inline math $...$
    .replace(/\$\$([^$]*)\$\$/g, (_, inner) => inner.trim())
    .replace(/\$([^$]*)\$/g, (_, inner) => inner.trim())
    // Remove \[...\] and \(...\) delimiters
    .replace(/\\\[([^\]]*)\\\]/g, (_, inner) => inner.trim())
    .replace(/\\\(([^)]*)\\\)/g, (_, inner) => inner.trim())
    // Remove remaining LaTeX command backslashes (e.g. \frac → frac)
    .replace(/\\([a-zA-Z]+)/g, "$1")
    // Collapse extra whitespace
    .replace(/\s+/g, " ")
    .trim();
};

/**
 * Converts HTML string to plain text by stripping all HTML tags
 * @param {string} html - HTML string to convert
 * @returns {string} - Plain text content
 */
export const stripHtmlTags = (html) => {
  if (!html) return "";
  
  // Create a temporary div element
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  
  // Get the text content, which automatically strips all HTML tags
  const text = tempDiv.textContent || tempDiv.innerText || "";
  return stripLatex(text);
};

/**
 * Extracts plain text from HTML and truncates to a maximum length
 * @param {string} html - HTML string to convert
 * @param {number} maxLength - Maximum length of returned text (default: 150)
 * @returns {string} - Truncated plain text content
 */
export const truncateHtmlText = (html, maxLength = 150) => {
  const plainText = stripHtmlTags(html);
  
  if (plainText.length <= maxLength) {
    return plainText;
  }
  
  return plainText.substring(0, maxLength).trim() + "...";
};
